import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const AuthContext = createContext(null);

const WORKER_URL = "https://aquint-task-management.aged-wildflower-4467.workers.dev";

function loadUserFromStorage() {
  try {
    const token = localStorage.getItem("tms_token");
    const saved = localStorage.getItem("tms_user");
    if (!token || !saved) return null;
    const u = JSON.parse(saved);
    if (u.exp && Date.now() > u.exp) {
      localStorage.removeItem("tms_token");
      localStorage.removeItem("tms_user");
      return null;
    }
    return u;
  } catch {
    return null;
  }
}

function consumeHashToken() {
  try {
    const hash = window.location.hash.slice(1);
    if (!hash) return null;
    const params = new URLSearchParams(hash);
    const token  = params.get("token");
    const user   = params.get("user");
    if (!token || !user) return null;
    const parsed = JSON.parse(decodeURIComponent(user));
    localStorage.setItem("tms_token", decodeURIComponent(token));
    localStorage.setItem("tms_user",  JSON.stringify(parsed));
    window.history.replaceState(null, "", window.location.pathname);
    return parsed;
  } catch {
    return null;
  }
}

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);

  const syncUser = useCallback(() => {
    setUser(loadUserFromStorage());
  }, []);

  useEffect(() => {
    const hashUser = consumeHashToken();
    if (hashUser) {
      setUser(hashUser);
      setLoading(false);
      return;
    }
    syncUser();
    setLoading(false);

    const onStorage = (e) => {
      if (e.key === "tms_token" || e.key === "tms_user") syncUser();
    };
    const onFocus = () => syncUser();
    window.addEventListener("storage", onStorage);
    window.addEventListener("focus",   onFocus);
    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("focus",   onFocus);
    };
  }, [syncUser]);

  const loginWithLark = () => {
    window.location.href = `${WORKER_URL}/auth/login`;
  };

  const logout = () => {
    localStorage.removeItem("tms_token");
    localStorage.removeItem("tms_user");
    setUser(null);
  };

  const getToken = () => localStorage.getItem("tms_token");

  return (
    <AuthContext.Provider value={{ user, loading, loginWithLark, logout, getToken }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
